import { Box } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkButton from "../../components/atoms/TkButton";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkStepper from "../../components/atoms/TkStepper";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { httpAPI_FAC006, httpAPI_FAC010 } from "./api/request";
import TkStaffChangesTable from "./components";
import { stepperData } from "./parts";
import {
  RetireeStatus,
  TransferReason,
  TransferStatus,
} from "../../assets/data/Constants";
import "./_style.scss";

/**
 * SCRC050108　　契約解除（経営者でなくなった）対象職員一覧
 * @return SCRC050108
 */
const SCRC050108 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const userType = state?.authInfo?.userType;
  const [bodyList, setBodyList] = useState<any>();
  const [selectedData, setSelectedData] = useState<any[]>();
  const isKiko = userType === authorityUserType.userTypeNumber.KIKO;
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [isTkStaffChangesHeadDisabled, setIsTkStaffChangesHeadDisabled] =
    useState(false);

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInit = async () => {
    try {
      const res = await httpAPI_FAC006({
        contractorNo: isKiko
          ? businessState.common?.contractorNo
          : state.authInfo?.contractorNo,
        applyId: businessState.job_02?.applyId,
        facilityNo: location.state?.facilityNo,
        transferDate: businessState.job_02?.noOwnerDate,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        const staffBodyList = funBodyList(res);
        setBodyList(staffBodyList);
        handleStaffChange(staffBodyList);
        setIsTkStaffChangesHeadDisabled(
          res.businessTransferSelectabilityFlg === "0"
        );
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  function funBodyList(res: any): any[] {
    const staffBodyList: any[] = [];
    res.staffSelectionList?.forEach((item: any, index: number) => {
      const data = {
        index: index,
        num: item?.staffNo,
        name: item.staffNameKanji,
        updateDateTime: item?.updateDateTime,
        transfer:
          item?.transferReason === TransferReason["経営移管減"]
            ? TransferStatus["選択"]
            : TransferStatus["未選択"],
        retirement:
          item?.transferReason === TransferReason["退職"]
            ? RetireeStatus["選択"]
            : RetireeStatus["未選択"],
      };
      staffBodyList.push(data);
    });
    return staffBodyList;
  }

  const handleClick = async () => {
    try {
      const res = await httpAPI_FAC010({
        contractorNo: isKiko
          ? businessState.common?.contractorNo
          : state.authInfo?.contractorNo,
        applyId: businessState.job_02?.applyId,
        facilityNo: location.state?.facilityNo,
        staffList: selectedData, //職員情報リスト
        businessType: businessState.common?.businessType, //業務タイプ
        transferDate: businessState.job_02?.noOwnerDate, //異動年月日
        screenId: "SCRC050108", //画面id
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC050107");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleStaffChange = (staffs: any[]) => {
    let tempSelectedData: any[] = [];
    let isAnySelected = false;
    staffs.forEach((staff) => {
      if (staff.transfer === TransferStatus["選択"]) {
        tempSelectedData.push({
          staffNo: staff.num,
          transferReason: TransferReason["経営移管減"],
          updateDateTime: staff.updateDateTime,
        });
        isAnySelected = true;
      }
      if (staff.retirement === RetireeStatus["選択"]) {
        tempSelectedData.push({
          staffNo: staff.num,
          transferReason: TransferReason["退職"],
          updateDateTime: staff.updateDateTime,
        });
        isAnySelected = true;
      }
    });
    setSelectedData(tempSelectedData);
    setIsSubmitDisabled(!isAnySelected);
  };

  return (
    <Box className="SCRC050108" data-testid="SCRC050108PageForTest">
      <TkStepper
        steps={stepperData}
        activeStep={location.state?.tempSaveStep ?? 0}
      />

      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC050108_01}</TkInfoManual>
      {isKiko && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={`${businessState.common?.contractorNo ?? ""}:${
            businessState.common?.contractorName ?? ""
          }`}
        />
      )}
      <TkStaffChangesTable
        staffs={bodyList}
        onChange={handleStaffChange}
        isTkStaffChangesHeadDisabled={isTkStaffChangesHeadDisabled}
      />

      <Box className="buttonGroup">
        <TkBackButton />
        <TkButton onClick={() => handleClick()} disabled={isSubmitDisabled}>
          登録
        </TkButton>
      </Box>
    </Box>
  );
};

export default SCRC050108;
